"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.when = void 0;
var _Observable = require("./Observable");
var when = exports.when = function when(notifier) {
  return function (source) {
    return (0, _Observable.mkObservable)(function (observer) {
      var buff;
      source.subscribe({
        next: function next(i) {
          buff = i;
        },
        error: function error(err) {
          return observer.error(err);
        },
        complete: function complete() {
          return void 8;
        } // observer.complete()
      });
      notifier.subscribe({
        next: function next() {
          if (typeof buff != "undefined") {
            observer.next(buff);
            buff = undefined;
          }
        },
        error: function error(err) {
          return observer.error(err);
        },
        complete: function complete() {
          return observer.complete();
        }
      });
    });
  };
};